import {ValueObject} from '@s-ui/domain'

import {QueryParamSharedValueObject} from '../../shared/ValueObjects/QueryParamSharedValueObject.js'
import {FilterRangeSearchValueObject} from './FilterRangeSearchValueObject.js'

export class FilterFeeSearchValueObject extends ValueObject {
  #fee

  constructor({fee}) {
    super()
    this.#fee = fee
  }

  static create({fee}) {
    return new FilterFeeSearchValueObject({fee: FilterRangeSearchValueObject.create(fee)})
  }

  static createWithDefaultValue({config, fee}) {
    const {DEFAULT_PRICE_SEARCH} = config.get('searchFilters')

    return new FilterFeeSearchValueObject({
      fee: FilterRangeSearchValueObject.create({
        from: fee?.from || DEFAULT_PRICE_SEARCH.from,
        to: fee?.to || DEFAULT_PRICE_SEARCH.to
      })
    })
  }

  static createFromUrl({config, url = ''}) {
    const {DEFAULT_PRICE_SEARCH} = config.get('searchFilters')
    const {SEMANTIC_KEYWORDS} = config.get('seo')
    const isRenting = url.startsWith('/renting/')

    if (isRenting && url.includes(SEMANTIC_KEYWORDS.RENTING.CHEAP)) {
      return new FilterFeeSearchValueObject({
        fee: FilterRangeSearchValueObject.create({
          from: null,
          to: 400
        })
      })
    }

    const urlQueryParms = new URLSearchParams(url.split('?')[1] || '')
    if (urlQueryParms.has('maxFee') || urlQueryParms.has('minFee')) {
      return new FilterFeeSearchValueObject({
        fee: FilterRangeSearchValueObject.create({
          from: urlQueryParms.get('minFee') || DEFAULT_PRICE_SEARCH.from,
          to: urlQueryParms.get('maxFee') || DEFAULT_PRICE_SEARCH.to
        })
      })
    }

    return FilterFeeSearchValueObject.createWithDefaultValue({config, fee: null})
  }

  static createQueryParams({config, fee}) {
    const {DEFAULT_PRICE_SEARCH, FILTER_NAMES, FILTER_QUERY_PARAMS} = config.get('searchFilters')

    return new FilterFeeSearchValueObject({
      fee: {
        from: QueryParamSharedValueObject.createForSingle({
          key: FILTER_QUERY_PARAMS[FILTER_NAMES.FEE].from,
          value: fee?.from || DEFAULT_PRICE_SEARCH.from
        }),
        to: QueryParamSharedValueObject.createForSingle({
          key: FILTER_QUERY_PARAMS[FILTER_NAMES.FEE].to,
          value: fee?.to || DEFAULT_PRICE_SEARCH.to
        })
      }
    })
  }

  get isEmpty() {
    return this.#fee.isEmpty
  }

  get queryParams() {
    return {
      ...(!this.#fee.from.isEmpty && {...this.#fee.from.queryParam}),
      ...(!this.#fee.to.isEmpty && {...this.#fee.to.queryParam})
    }
  }

  get value() {
    return this.#fee.value
  }

  toJSON() {
    return {
      fee: this.#fee.toJSON()
    }
  }
}
